export default __webpack_public_path__ + "static/media/timeIcon.aaae3b02.svg";